import { initialStateAR } from './initialState';
import {
    GET_POLICIES,
    GET_POLICY,
    ADMIN_CHANGE,
    GET_STATICS,
    UPDATE_POLICY,
    SET_CURRENT_PAGE,
    SET_POL_FILTERS,
    SET_POL,
    SET_SIN_FILTERS,
    SET_SIN,
    CHANGE_LAST_STATE,
    RESET_STATICS,
} from "../actions/types";
import { totalShow } from '../utilities';

export default function adminReducer(state = initialStateAR, { type, payload }) {
    switch (type) {
        case ADMIN_CHANGE: {
            return {
                ...state,
                policy: { ...state.policy, [payload.name]: payload.value },
            };
        }
        case UPDATE_POLICY: {
            return {
                ...state,
                policy: payload,
            }
        }
        case GET_POLICY: {
            return {
                ...state,
                policy: payload.policy,
                cities: payload.cities,
                payment: payload.payment,
            }
        }
        case CHANGE_LAST_STATE: {
            return {
                ...state,
                policies: state.policies.map(pol => {
                    if (pol['int-pol'] === payload.intpol) {
                        return { ...pol, 'est-pol': payload.estpol }
                    } else {
                        return pol
                    }
                })
            }
        }
        case GET_POLICIES: {
            return {
                ...state,
                policies: payload.policies,
                polFilters: {
                    ...state.polFilters,
                    lastPage: payload.lastPage,
                    currentPage: 0,
                },
                enterprises: payload.enterprises,
                loading: false,
            };
        }
        case SET_CURRENT_PAGE: {
            return {
                ...state,
                polFilters: {
                    ...state.polFilters,
                    currentPage: payload,
                }
            }
        }
        case SET_POL_FILTERS: {
            return {
                ...state,
                polFilters: {
                    ...state.polFilters,
                    filters: payload,
                }
            }
        }
        case SET_SIN_FILTERS: {
            return {
                ...state,
                sinFilters: payload,
            }
        }
        case SET_SIN: {
            return {
                ...state,
                sinisters: payload,
                loading: false,
            }
        }
        case SET_POL: {
            const lastPage = Math.ceil(payload.length / totalShow);

            return {
                ...state,
                policies: payload,
                polFilters: {
                    ...state.polFilters,
                    currentPage: 0,
                    lastPage,
                }
            };
        };
        case GET_STATICS: {
            return {
                ...state,
                statics: { ...state.statics, [payload.type]: { ...payload, loaded: true } },
            }
        };
        case RESET_STATICS: {
            return {
                ...state,
                statics: {
                    s: {
                        empleados: 0,
                        datasets: [],
                        iniciadas: 0,
                        finalizadas: 0,
                        canceladas: 0,
                        ventas: [],
                        sucursales: [],
                        regiones: [],
                        zonas: [],
                        loaded: false,
                    },
                    r: {
                        empleados: 0,
                        datasets: [],
                        iniciadas: 0,
                        finalizadas: 0,
                        canceladas: 0,
                        ventas: [],
                        sucursales: [],
                        regiones: [],
                        zonas: [],
                        loaded: false,
                    },
                    z: {
                        empleados: 0,
                        datasets: [],
                        iniciadas: 0,
                        finalizadas: 0,
                        canceladas: 0,
                        ventas: [],
                        sucursales: [],
                        regiones: [],
                        zonas: [],
                        loaded: false,
                    },
                    a: {
                        empleados: 0,
                        datasets: [],
                        iniciadas: 0,
                        finalizadas: 0,
                        canceladas: 0,
                        ventas: [],
                        sucursales: [],
                        regiones: [],
                        zonas: [],
                        loaded: false,
                    },
                },
            }
        };
        default: {
            return state;
        };
    }
}
